import RelatorioEmDesenvolvimento from "../../../components/RelatorioEmDesenvolvimento";

const MonitClimaIrri = () => (
  <RelatorioEmDesenvolvimento
    titulo="Monitoramento Climático e Irrigação"
    descricao="Vai depender de integração com estação meteorológica e/ou sistema de irrigação."
  />
);

export default MonitClimaIrri;
